module.exports = __webpack_public_path__ + "img/treasure-home-logo.7d4ba043.png";